import React, { useEffect, useContext, useState, useRef } from 'react'
import { fondDeLEcran } from "../../Formats/FormatsHelpers"
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { v4 as uuidv4 } from 'uuid';

import { useNavigate } from 'react-router-dom';

import {
  Box,
  Popover,
} from '@mui/material';

import moreForAdmin from '../../../../images/moreForAdmin.svg'
import addForAdmin from '../../../../images/addForAdmin.svg'
import dragForAdmin from '../../../../images/dragForAdmin.svg'

import APIS from "../../../../utils/APIS"
import listFormats from "../../../../utils/listFormats"

import SuperAdminContext from "../../../../contexts/SuperAdminContext"
import PopupNotifContext from "../../../../contexts/PopupNotifContext"



import { FormatSwitch } from "../../../../pages/Formation"
import ScaleThumbForm from "../../Formation/ScaleThumbForm"

const AddFormatPopover = ({open, anchorEl, onClose, addFct, iChap, iPart, iSeq}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Box sx={{
        userSelect:"none",
        padding:"0px 5px",
        color:"black",
      }}>
        <Box
          sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("Titre"))
            onClose()
          }}
        >
          Format Titre
        </Box>
        <Box
          sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("Texte"))
            onClose()
          }}
        >
          Format Texte
        </Box>
        <Box
          sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("Video"))
            onClose()
          }}
        >
          Format Vidéo
        </Box>
        <Box
          sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("QuestionnaireV2"))
            onClose()
          }}
        >
          Format QuestionnaireV2
        </Box>
        {/* Audit de taxonomie 18/09/2026 : la creation distingue desormais
            EXPLICITEMENT les deux usages du quiz. Les deux produisent le meme
            `type: 'Quizz'` ; seule `answers.quizVariant` les separe. Avant, il
            n'existait qu'une entree « Format Quizz » qui semait VRAI/FAUX : on ne
            pouvait donc pas savoir ce que l'auteur avait voulu faire. */}
        <Box
          sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("Quizz"))
            onClose()
          }}
        >
          Format Quiz QCM
        </Box>
        <Box
          sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("QuizzVraiFaux"))
            onClose()
          }}
        >
          Format Quiz Vrai / Faux
        </Box>
        <Box
          sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("Diagnostic"))
            onClose()
          }}
        >
          Format Diagnostic
        </Box>
        {/* 07/10/2026 : le score du module et la rosette du certificat, avec
            deux textes (fiche Notion de Nawal, partie B). En general la
            derniere slide du module. */}
        <Box
          sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("FinDeModule"))
            onClose()
          }}
        >
          Format Fin de module
        </Box>
        <Box
          sx={{padding:"10px", cursor:"pointer"}}
          onClick={() => {
            addFct({iChap : iChap, iPart: iPart, iSeq: iSeq}, listFormats("InputTexte"))
            onClose()
          }}
        >
          Format Input Texte
        </Box>

      </Box>
    </Popover>
  )
}

const SideBarSequence = ({ content, updateContent, chapId, partId, seqId, iChap, iPart, iSeq, actIndex, setIndex }) => {

  const { addSequence, deleteSequence, duplicateSequence } = useContext(SuperAdminContext)
  const { addPopupNotif } = useContext(PopupNotifContext)

  const popoverRef = useRef()
  const [menuOpen, setMenuOpen] = useState(false)

  const addPopoverRef = useRef()
  const [addMenuOpen, setAddMenuOpen] = useState(false)
  const addPopoverRef2 = useRef()
  const [addMenuOpen2, setAddMenuOpen2] = useState(false)

  const [active, setActive] = useState(false)

  useEffect(() => {
    if (actIndex?.chapitre === iChap && actIndex?.partie === iPart && actIndex?.sequence === iSeq) {
      setActive(true)
    } else {
      setActive(false)
    }
  }, [iChap, iPart, iSeq, actIndex])


  return (
    <Draggable
      key={'key_plan_chap_card_' + seqId + '_' + partId + '_' + chapId}
      draggableId={'drag_seq_id_' + seqId}
      index={iSeq}
    >
      {(provided, snapshot) => (
        <Box
          ref={provided.innerRef}
          {...provided.draggableProps}
          sx={{
            height:"110px",
            background:active&&"rgba(255,165,0, 0.2)",
            position:"relative",
            "&:hover" : {
              ".viewOnHover" : {
                opacity:"1 !important",
              }
            },
          }}
        >
          {iSeq === 0 &&
            <>
              <Box
                ref={addPopoverRef2}
                sx={{
                  position:"absolute",
                  width:"100px",
                  height:"10px",
                  top:"-5px",
                  left:"95px",
                  zIndex:2,
                  opacity:0,
                  cursor:"pointer",
                  "&:hover" : {
                    opacity:1,
                  },
                }}
                onClick={() => {
                  setAddMenuOpen2(true)
                }}
              >
                <Box sx={{height:"1px", background:"black", width:"45px", position:"absolute", left:0, top:"5px", }} />
                <Box sx={{height:"1px", background:"black", width:"45px", position:"absolute", left:"55px", top:"5px", }} />
                <img src={addForAdmin} style={{width:"10px", position:"absolute", top:0, left:"45px", zIndex:3}} />
              </Box>
              <AddFormatPopover
                open={addMenuOpen2}
                anchorEl={addPopoverRef2?.current}
                onClose={() => setAddMenuOpen2(false)}
                addFct={addSequence}
                iChap={iChap}
                iPart={iPart}
                iSeq={iSeq}
              />
            </>
          }
          <Box
            ref={addPopoverRef}
            sx={{
              position:"absolute",
              width:"100px",
              height:"10px",
              bottom:"-5px",
              left:"95px",
              zIndex:2,
              opacity:0,
              cursor:"pointer",
              "&:hover" : {
                opacity:1,
              },
            }}
            onClick={() => {
              setAddMenuOpen(true)
            }}
          >
            <Box sx={{height:"1px", background:"black", width:"45px", position:"absolute", left:0, top:"5px", }} />
            <Box sx={{height:"1px", background:"black", width:"45px", position:"absolute", left:"55px", top:"5px", }} />
            <img src={addForAdmin} style={{width:"10px", position:"absolute", top:0, left:"45px", zIndex:3}} />
          </Box>
          <AddFormatPopover
            open={addMenuOpen}
            anchorEl={addPopoverRef?.current}
            onClose={() => setAddMenuOpen(false)}
            addFct={addSequence}
            iChap={iChap}
            iPart={iPart}
            iSeq={iSeq+1}
          />
          <Box sx={{
            height:"calc(100% - 5px)",
            paddingTop:"6px",
            display:"flex",
            gap:"8px",
            paddingLeft:"48px",
          }}>
            <Box>
              <Box
                ref={popoverRef}
                sx={{flexShrink:0, opacity:1, cursor:"pointer", userSelect:"none"}}
                onClick={(e) => {
                  e.stopPropagation()
                  setMenuOpen(!menuOpen)
                }}
              >
                {menuOpen ? (
                  <img src={addForAdmin} style={{width:"16px", transform:"rotate(45deg)"}} />
                ) : (
                  <img src={moreForAdmin} className="viewOnHover" style={{width:"16px", opacity:active?1:0}} />
                )}
                <Popover
                  open={menuOpen}
                  anchorEl={popoverRef?.current}
                  onClose={() => setMenuOpen(false)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <Box sx={{
                    userSelect:"none",
                    padding:"0px 5px",
                    color:"black",
                  }}>
                    <Box
                      sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                      onClick={() => { deleteSequence({ iChap: iChap, iPart: iPart, iSeq: iSeq }) }}
                    >
                      Supprimer
                    </Box>
                    <Box
                      sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                      onClick={() => { duplicateSequence({ iChap: iChap, iPart: iPart, iSeq: iSeq }) }}
                    >
                      Dupliquer
                    </Box>
                    <Box
                      sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                      onClick={() => {
                        let sequence = JSON.stringify(content?.chapitre[iChap]?.partie[iPart].sequence[iSeq])
                        localStorage.setItem('copyPasteFormation', JSON.stringify({type:"formationSequence", format : sequence}));
                        addPopupNotif({
                          uuid : uuidv4(),
                          title : "Séquence copiée",
                          type : "confirm",
                          removeAfter:3000,
                        })
                      }}
                    >
                      Copier
                    </Box>
                    <Box
                      sx={{padding:"10px", cursor:"pointer"}}
                      onClick={() => {
                        let infos = JSON.parse(localStorage.getItem('copyPasteFormation'))
                        if (infos && infos?.format && infos?.type === "formationSequence") {
                          let newSequence = JSON.parse(infos.format)
                          addSequence({iChap : iChap, iPart: iPart, iSeq: iSeq + 1}, newSequence)
                        } else {
                          addPopupNotif({
                            uuid : uuidv4(),
                            title : "Aucune données",
                            type : "error",
                            removeAfter:3000,
                          })
                        }
                      }}
                    >
                      Coller (après)
                    </Box>
                  </Box>
                </Popover>
              </Box>
            </Box>
            <Box
              {...provided.dragHandleProps}
              sx={{
                aspectRatio:"1.5",
                height:"100%",
                overflow:"hidden",
                cursor:"grab",
              }}
            >
              <ScaleThumbForm grabCursor fond={fondDeLEcran(content?.chapitre[iChap]?.partie[iPart]?.sequence[iSeq])} onClick={() => {
                setIndex({chapitre:iChap, partie:iPart, sequence:iSeq})
              }}>
                <FormatSwitch
                  actFormation={content}
                  format={content?.chapitre[iChap]?.partie[iPart]?.sequence[iSeq]}
                  actIndex={{chapitre : iChap, partie : iPart, sequence : iSeq}}
                  //actPlan={actPlan}
                  onlyContent
                />
              </ScaleThumbForm>
            </Box>
          </Box>

        </Box>
      )}
    </Draggable>
  )
};

export default SideBarSequence
